import BaseModel from '../core/BaseModel'
export default class ServicePackServiceSupplies extends BaseModel {
    constructor() {
        super({
                name: "service_pack_service_supplies",
                tableName: 'core_service_pack_service_supplies',
                display_key: 'name'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                obj_service_supplies: {
                    refs: 'obj_service_supplies { id code name unit unit_price }',
                    display: false
                },

            },)
    }

}